import React from "react";
import {motion} from "framer-motion";
// import { ThemeContext } from "../themeProvider";

const Card = (props) => {
  // const theme = useContext(ThemeContext);
  // const darkMode = theme.state.darkMode;
    return (
        <motion.div
        initial="hidden"
        whileInView={"visible"}
        variants={{
          visible: { opacity: 1, scale: 1 },
          hidden: { opacity: 0, scale: 0 },
        }}
        className="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg dark:bg-gray-800 dark:border-gray-700 my-8"
      >
        <a href={props.url}>
            </a>
            <img className="rounded-t-lg w-full" src={props.image} alt="Loading ... " style={{ minHeight: '385px'}} />
        <div className="p-5">
                <a href={props.url}>
                    <h5
                        className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {props.name}
                    </h5>
                </a>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                    {props.summary}
                </p>
                <a
                    href={props.url}
            className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-200 focus:ring-4 focus:outline-none focus:ring-blue-300">
                    Live URL
                    <svg
                        className="ml-2 -mr-1 w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clipRule="evenodd"></path>
                    </svg>
                </a>
                <a
                    href={props.github}
            className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-200 focus:ring-4 focus:outline-none focus:ring-blue-300" style={{marginLeft:'250px'}}>
                    Project on GitHub
                    <svg
                        className="ml-2 -mr-1 w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clipRule="evenodd"></path>
                    </svg>
                </a>
            </div>
        </motion.div>
    );
};

export default Card;
